{
  "version": 1,
  "asset_id": "32ca720a-daea-4077-968a-23f597f126b7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/32ca720a-daea-4077-968a-23f597f126b7/sleeve-ugi-reflux-pre-899.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/32ca720a-daea-4077-968a-23f597f126b7/sleeve-ugi-reflux-pre-899.jpg",
  "original_filename": "sleeve-ugi-reflux-pre-899.jpg",
  "size": 96227,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:38:29Z"
}
